import type { RuntimeModel } from './modelCatalog';

export const DEFAULT_HELPER_MODEL = 'deepinfra-deepseek-v4-flash';
export type GmSpeed = 'fast' | 'low' | 'medium' | 'high';
/** Bounds optional work; never reduces canonical rules, context or the player's response length. */
const SPEED_POLICIES = {
  fast: { planningSteps:6, planningTokens:2048, narrationSteps:3, researchCalls:1, researchSteps:4, researchTokens:1024 },
  low: { planningSteps:9, planningTokens:3072, narrationSteps:4, researchCalls:1, researchSteps:5, researchTokens:1536 },
  medium: { planningSteps:12, planningTokens:4096, narrationSteps:6, researchCalls:2, researchSteps:6, researchTokens:2048 },
  high: { planningSteps:20, planningTokens:6144, narrationSteps:8, researchCalls:4, researchSteps:8, researchTokens:3072 },
} as const;
export function gmPolicy(value:unknown) {
  const mode:GmSpeed = value === 'fast' || value === 'low' || value === 'high' ? value : 'medium';
  return {mode,...SPEED_POLICIES[mode]};
}
export function roleModelId(value:unknown, fallback=DEFAULT_HELPER_MODEL):string {
  return typeof value === 'string' && value.trim() ? value.trim() : fallback;
}
/** An unavailable explicit model is an error, never a silent switch to the GM. */
export function requireRoleModel(catalog:readonly RuntimeModel[], id:string, role:string):string {
  const model=catalog.find(item=>item.id===id && item.available);
  if(!model) throw new Error(`โมเดล ${role} ไม่พร้อมใช้งาน (${id}) กรุณาเลือกใหม่`);
  return model.id;
}
export interface ResearchPolicy { model:string; maxCalls:number; maxSteps:number; maxOutputTokens:number }
export function researchPolicy(model:unknown, speed:unknown='medium'):ResearchPolicy {
  const policy=gmPolicy(speed);
  return {model:roleModelId(model),maxCalls:policy.researchCalls,maxSteps:policy.researchSteps,maxOutputTokens:policy.researchTokens};
}
